import { RootState } from '../reducers'

export const variableDataSelector = (state: RootState) => {
  return state.renderer.variableData
}

export const isVariableDataLoadingSelector = (state: RootState) => {
  return state.renderer.isVariableDataLoading
}
